const Logger = {
  error(msg) {
    console.error(msg)
  },
}

export default Logger
